

















































































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue'
import { ContactAnonModule } from '@/store/modules/contactAnon';
import { AppModule } from '@/store/modules/app';
import ContactOfferConfirmationConfirmDecline from '@/components/AnonContacts/ContactOfferConfirmationConfirmDecline.vue';
import AnonJobWorkerOfferDto from '@/models/AnonJobWorkers/AnonJobWorkerOfferDto';

@Component({
  name: 'JobOfferConfirmation',
  components: { ContactOfferConfirmationConfirmDecline }
})
export default class InterviewConfirmation extends GiganautVue {

    get offerConfirmation(): AnonJobWorkerOfferDto {
        return ContactAnonModule.offerConfirmation;
    }

    get loading() {
        return ContactAnonModule.loading;
    }

    get agency() {
        return AppModule.currentAgencyContext;
    }

    get isConfirmationSubmitted() {
        return ContactAnonModule.isJobOfferConfirmationSubmitted;
    }
}
